import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTempEdgeTranslator } from '../../../Hooks/useTranslation';
import { withPathLocale } from '../../../utils/helpers/localePreference';

/**
 * Rewrites the trailing locale segment of the current route whenever the language or the route
 * changes, so a reload or a shared link opens in the language on screen.
 * @returns {null} Nothing is rendered.
 * @author armandoricosandoval -ai-
 */
const LocaleUrlSync = () => {
  const { locale } = useTempEdgeTranslator();
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const localizedPath = withPathLocale(pathname, locale);
    if (localizedPath !== pathname) {
      navigate(`${localizedPath}${search}${hash}`, { replace: true });
    }
  }, [locale, pathname]);

  return null;
};

export default LocaleUrlSync;
